import { render } from "./FormOrderOverview.vue?vue&type=template&id=8dfde488&scoped=true"
import script from "./FormOrderOverview.vue?vue&type=script&lang=js"
export * from "./FormOrderOverview.vue?vue&type=script&lang=js"

import "./FormOrderOverview.vue?vue&type=style&index=0&id=8dfde488&scoped=true&lang=css"

import exportComponent from "/Users/filip/coding/shean/reklamace/reklamace-fe-slovakova/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dfde488"]])

export default __exports__